var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-r d-flex-center tag"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.tagIndex)}}},[_vm._v("×")])])
}
var staticRenderFns = []

export { render, staticRenderFns }